import React from 'react'

export default function ActivityFilters({
  filter,
  setFilter,
  supportNeed,
  setSupportNeed,
  dimension,
  setDimension,
  supportOptions,
  dimensionOptions,
  selectedGrade,
  setSelectedGrade,
  gradeOptions,
  selectedTopic,
  setSelectedTopic,
  topicOptions
}) {
  return (
    <div className="grid cols-3 filter-grid">
      <div className="surface-card compact">
        <label className="form-label">Formato</label>
        <div className="button-wrap">
          {['all', 'practice', 'game', 'blockly'].map((type) => (
            <button key={type} type="button" onClick={() => setFilter(type)} className={`chip ${filter === type ? 'chip-active' : ''}`}>
              {type === 'all' ? 'Todas' : type === 'practice' ? 'Práticas' : type === 'game' ? 'Games' : 'Blocos'}
            </button>
          ))}
        </div>
      </div>
      <div className="surface-card compact">
        <label className="form-label">Série</label>
        <select value={selectedGrade} onChange={(e) => setSelectedGrade(Number(e.target.value))} className="input">
          {gradeOptions.map((item) => <option key={item.value} value={item.value}>{item.label}</option>)}
        </select>
      </div>
      <div className="surface-card compact">
        <label className="form-label">Assunto BNCC</label>
        <select value={selectedTopic} onChange={(e) => setSelectedTopic(e.target.value)} className="input">
          <option value="all">Todos os assuntos da série</option>
          {topicOptions.map((item) => <option key={item} value={item}>{item}</option>)}
        </select>
      </div>
      <div className="surface-card compact">
        <label className="form-label">Dimensão</label>
        <select value={dimension} onChange={(e) => setDimension(e.target.value)} className="input">
          {dimensionOptions.map((item) => <option key={item.value} value={item.value}>{item.label}</option>)}
        </select>
      </div>
      <div className="surface-card compact">
        <label className="form-label">Perfil de suporte</label>
        <select value={supportNeed} onChange={(e) => setSupportNeed(e.target.value)} className="input">
          {supportOptions.map((item) => <option key={item.value} value={item.value}>{item.label}</option>)}
        </select>
      </div>
    </div>
  )
}
